/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseSalePointMenuDto } from '../../models/api-response-sale-point-menu-dto';
import { SalePointMenuDto } from '../../models/sale-point-menu-dto';

export interface UpdateSalePointMenu$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  reference: string;
      body: SalePointMenuDto
}

export function updateSalePointMenu(http: HttpClient, rootUrl: string, params: UpdateSalePointMenu$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseSalePointMenuDto>> {
  const rb = new RequestBuilder(rootUrl, updateSalePointMenu.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('reference', params.reference, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseSalePointMenuDto>;
    })
  );
}

updateSalePointMenu.PATH = '/v1/api/sale-points/{reference}/menu';
